const light = {
  colors: {
    primary: {
      _400: '#FFA3FA',
      _500: '#FF72F7',
      _600: '#D600CA'
    },
    secondary: {
      _400: '#F6DFE2',
      _500: '#ECB7BF',
      base: '#ECB7BF',
      _600: '#E18E9B',
      _700: '#BE3247'
    },
    neutrals: {
      _000: '#FFFFFF',
      _100: '#F2F2F3',
      _200: '#E2E2E2',
      _300: '#C8CDD0',
      _400: '#768289',
      _500: '#647796',
      _600: '#54647D',
      _700: '#4B5A71',
      _800: '#455368',
      _900: '#313A49',
      textDefault: '#455368'
    },
    accent1: {
      _100: '#FF72B0',
      _300: '#C172FF'
    },
    accent2: {
      _100: '#ECC9B7',
      _300: '#ECB7D9'
    }
  },
  background: function () {return this.colors.neutrals._000 },
  bold: '700',
  bleed: '5',
  grid: {
    noOfColumns: 12,
    columnSizeInVw: 7,
    columnSizeInPx: 72,
    maxSizeInVw: function () { return `${this.columnSizeInVw * this.noOfColumns}vw` },
    maxSizeInPx: function() { return `${this.columnSizeInPx * this.noOfColumns}px` }
  },
  mobileWidth: '896px'
};

const contrastLight = {
  ...light,
  colors: {
    ...light.colors,
    neutrals: {
      _000: light.colors.neutrals._900,
      _100: light.colors.neutrals._800,
      _200: light.colors.neutrals._700,
      _300: light.colors.neutrals._600,
      _400: light.colors.neutrals._500,
      _500: light.colors.neutrals._400,
      _600: light.colors.neutrals._300,
      _700: light.colors.neutrals._200,
      _800: light.colors.neutrals._100,
      _900: light.colors.neutrals._000,
      textDefault: light.colors.neutrals._000
    },
  }
}

export const useThemes = () => ({ light, contrastLight });